'use client';

import React, { useEffect, useState } from 'react';
import { Typography } from 'src/components/PulseUI';
import { useDebounce } from 'use-debounce';

interface SmoothnessControlProps {
  onSubmit: (smooth: number[]) => void;
}

const SmoothnessControl = ({ onSubmit }: SmoothnessControlProps) => {
  const [smoothness, setSmoothness] = useState<number>(1);
  const [debouncedSmoothness] = useDebounce(smoothness, 500);

  useEffect(() => {
    if (debouncedSmoothness !== smoothness) return;
    // submit form with debounce value
    onSubmit([debouncedSmoothness]);
  }, [debouncedSmoothness]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSmoothness(Number(event.target.value));
  };

  const percentage = ((smoothness - 1) / (100 - 1)) * 100;

  return (
    <div className="-mb-7">
      <div className="flex justify-between">
        <Typography variant="body2">Smoothness</Typography>
        <Typography variant="body2">{smoothness}%</Typography>
      </div>
      <input
        type="range"
        onChange={handleChange}
        defaultValue={1}
        value={smoothness}
        min={1}
        max={100}
        step={1}
        aria-label="Smoothness"
        className="w-full h-1.5 rounded-full appearance-none cursor-pointer
          [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:h-4
          [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-sky-600 [&::-webkit-slider-thumb]:cursor-pointer
          [&::-webkit-slider-thumb]:border-0 [&::-webkit-slider-thumb]:shadow-md
          [&::-moz-range-thumb]:w-4 [&::-moz-range-thumb]:h-4 [&::-moz-range-thumb]:rounded-full
          [&::-moz-range-thumb]:bg-sky-600 [&::-moz-range-thumb]:border-0 [&::-moz-range-thumb]:cursor-pointer"
        style={{
          background: `linear-gradient(to right, #0284c7 ${percentage}%, #e2e8f0 ${percentage}%)`,
        }}
      />
    </div>
  );
};

export default SmoothnessControl;
